module.exports = __webpack_public_path__ + "img/google_light.f5130d4e.svg";